import * as React from 'react';
import NextPreviousButtons from '../NextPreviousButtons';

import {
	TextInput,
	DropdownInput
} from '../../../../components/forms';

interface Props {
	user: UserDetails;
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (value?: {}) => void;
	onQuestionnaireHeightWeightBlur: (e: any) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const HeightQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		return !props.questionnaire.height;
	};
	return (
		<div>
			<TextInput
				labelText={props.questions.height}
				name="height"
				pattern="[0-9]*"
				max={props.questionnaire.heightUnit === 'in' ? 11 : undefined}
				value={props.questionnaire.height}
				onBlur={props.onQuestionnaireHeightWeightBlur}
				onChange={props.onQuestionnaireChange}
				className="form-group-height"
				addOnBefore={
					props.questionnaire.heightUnit === 'in' ? (
						<TextInput
							name="heightft"
							pattern="[0-9]*"
							max={8}
							value={props.questionnaire.heightft}
							onBlur={props.onQuestionnaireHeightWeightBlur}
							onChange={props.onQuestionnaireChange}
							addOnAfter="ft"
						/>
					) : (
							undefined
						)
				}
				addOnAfter={
					<DropdownInput
						name="heightUnit"
						options={[{ text: 'in', value: 'in' }, { text: 'cm', value: 'cm' }]}
						value={props.questionnaire.heightUnit}
						onBlur={props.onQuestionnaireHeightWeightBlur}
						onChange={props.onQuestionnaireChange}
					/>
				}
			/>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default HeightQuestion;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/basicQuestions/HeightQuestion.tsx